export default "__VITE_ASSET__BlRr4DSf__"